export default "__VITE_ASSET__5412f2dd__"